// extracted by mini-css-extract-plugin
module.exports = {"content":"mainContent_content__3C98z","upward":"mainContent_upward__goRK1","text":"mainContent_text__3Rd7t"};